import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll position to the top on every route change so navigating
// (logo, "Home", "About", "Read my story", etc.) never leaves the user
// stranded mid-page. Skips when an in-page anchor (#hash) is present so
// smooth-scroll anchor links (e.g. /#how-it-works) keep working.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
